import React, {useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { getAcademyStats } from "../../api/Api";
import PageContainer from '../../shared/PageContainer';
import SkillTree from './SkillTree';
import { getAcademyTrack } from './skillTreeData';
import CyberpunkTitle from '../../shared/CyberpunkTitle';
import QuizCallout from '../TechQuiz/QuizCallout';

interface PropsAcademy {
    token: string;
    track?: string;
}

interface Stats {
    challenges: number;
    solved: number;
}

const Academy = (props: PropsAcademy) => {
    const [stats, setStats] = useState<Record<string, Stats>>({});
    const token = props.token;
    const track = getAcademyTrack(props.track);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getAcademyStats(token);
            const statsMap: Record<string, Stats> = {};
            for (let i = 0; i < data.stats.length; i++) {
                statsMap[data.stats[i].category] = data.stats[i];
            }
            setStats(statsMap);
        }
        fetchData();
    }, []);

    return (
        <PageContainer>
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                <CyberpunkTitle
                    segments={[
                        { label: track.title },
                    ]}
                    mb="24px"
                />
                <QuizCallout trackSlug={track.slug} mb="32px" />
                <SkillTree tiers={track.tiers} stats={stats} token={token} />
            </Box>
        </PageContainer>
    );
}

export default Academy;
